import React from 'react'
import {
	DeleteButton,
	Edit,
	SimpleForm,
	TextInput,
	NumberInput,
	RadioButtonGroupInput,
	minLength,
	ReferenceInput,
	SelectInput,
	required,
	email,
	BooleanInput,
	FormDataConsumer,
	SaveButton,
	Toolbar,
	useNotify,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

import Permission from '../../components/Permission';
import { EmailVerificationWarning } from '../../components/EmailVerificationAlerts';
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton';
import { PERMISSIONS } from '../../constants';

const validatePassword = [minLength(6)];
const validateLogin = [required(), email()];


export default props => {
	const transform = data => {
		delete data.profile;
		return data;
	};
	const notify = useNotify();
	const navigate = useNavigate();

	const onSuccess = () => {
    notify('ra.notification.updated', { messageArgs: { smart_count: 1 } });
    navigate('/system-users');
  }

	const SystemUserEditToolbar = () => (
		<Toolbar sx={{ gap: 1 }}>
			<SaveButton />
			<Permission permission={PERMISSIONS.ADMIN}>
				<MarkVerifiedButton size="medium" />
			</Permission>
			<Permission permission={PERMISSIONS.UPDATE_USER}>
				<DeleteButton mutationMode="pessimistic" redirect="/system-users" confirmTitle="Excluir usuário" sx={{ marginLeft: 'auto' }} />
			</Permission>
		</Toolbar>
	);

	return (
		<Permission permission={PERMISSIONS.UPDATE_USER}>
			<Edit {...props} actions={false} resource="employees" transform={transform} title="Editar usuário" mutationMode="optimistic" mutationOptions={{ onSuccess }}>
				<SimpleForm sx={{ maxWidth: 600 }} toolbar={<SystemUserEditToolbar />}>
					<EmailVerificationWarning />
					<TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
					<TextInput source="login" label="Login" validate={validateLogin} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
					<TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
					<NumberInput source="maxPoints" label="Pontos por CPF" InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
					<FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                sx={{ width: 220 }}
                source="profileId"
                reference="profiles"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={{ type: 'admin' }}>
                <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
					<BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
				</SimpleForm>
			</Edit>
		</Permission>
	)
}
